import { useWeb3React } from '@web3-react/core'
import { BigNumber, utils } from 'ethers'
import React from 'react'
import styled from 'styled-components'
import WalletConnect from '../../assets/metamask.png'
import { Breakpoints, Colors } from '../../constants'
import { useETHBalance, useModal } from '../../hooks'
import { Box, Icon } from '../index'

const WalletInformationContainer = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
`

const WalletBalanceContainer = styled.div`
  color: ${Colors.WHITE};
  display: flex;
  flex-direction: row;
  background-color: ${Colors.CINDER};
  padding: 10px 30px 10px 20px;
  border-radius: 10px;
  align-items: center;

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
  }

  @media only screen and (min-width: ${Breakpoints.TABLET}px) {
  }
`

const WalletText = styled.div`
  font-weight: 600;

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    font-size: 10px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    font-size: 12px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    font-size: 14px;
  }
`

const WalletAddressContainer = styled.div`
  position: relative;
  color: ${Colors.WHITE};
  display: flex;
  flex-direction: row;
  background-color: ${Colors.BLACK};
  border: 2px solid ${Colors.BLUE};
  border-radius: 10px;
  right: 20px;
  align-items: center;

  @media only screen and (max-width: ${Breakpoints.MOBILE_S}px) {
    padding: 10px 20px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE_S}px) and (max-width: ${Breakpoints.MOBILE}px) {
    padding: 10px 20px;
  }

  @media only screen and (min-width: ${Breakpoints.MOBILE}px) {
    padding: 10px 20px;
  }

  @media only screen and (min-width: ${Breakpoints.TABLET}px) {
  }
`

export const WalletInformation = () => {
  const { toggleModal } = useModal()
  const { account } = useWeb3React()
  const balance = useETHBalance() || BigNumber.from(0)
  const address = account || '0x000000000000000000000'

  const shortAddress =
    address.substring(0, 6) +
    '...' +
    address.substring(address.length - 6, address.length - 1)
  let shortBalance = utils.formatEther(balance)
  const splitDecimals = shortBalance.split('.')
  if (splitDecimals[1] && splitDecimals[1].length > 3) {
    shortBalance = splitDecimals[0] + '.' + splitDecimals[1].substring(0, 3)
  }
  return (
    <WalletInformationContainer onClick={() => toggleModal('connect')}>
      <WalletBalanceContainer>
        <WalletText>{shortBalance} ETH</WalletText>
      </WalletBalanceContainer>
      <WalletAddressContainer>
        <WalletText>{shortAddress}</WalletText>
        <Box marginLeft="xs">
          <Icon size="s" src={WalletConnect} />
        </Box>
      </WalletAddressContainer>
    </WalletInformationContainer>
  )
}
